/** What a question card (S-525, Paper "Chat cards · spike (S-525)") says, from its message's data. */
import type { ChoiceData } from "./api";

export type ChoiceView =
  | { state: "open"; question: string; options: string[] }
  /** Answered: the option tapped, or null when someone wrote in the thread instead. */
  | { state: "answered"; question: string; answer: string | null; by: string; at: string };

const LETTERS = "ABCD";

/** "A", "B", …: the letter an answer's row shows. */
export const letterOf = (index: number) => LETTERS[index] ?? String(index + 1);

/** The card's data, read defensively: an older or partial message is an open card of nothing. */
export function choiceView(data: Record<string, unknown>, viewerId: string): ChoiceView {
  const d = data as Partial<ChoiceData>;
  const question = typeof d.question === "string" ? d.question : "";
  const options = Array.isArray(d.options) ? d.options.map(String) : [];
  const answer = d.answer;
  if (!answer || typeof answer !== "object") return { state: "open", question, options };
  const picked = typeof answer.option === "number" ? (options[answer.option] ?? null) : null;
  const first = (answer.name ?? "").trim().split(/\s+/)[0] || "Someone";
  return {
    state: "answered",
    question,
    answer: picked,
    by: answer.by === viewerId ? "You" : first,
    at: answer.at,
  };
}
